<template>
  <div class="body">
    <div class="common-page dark-theme">
      <div class="wrap">
        <a href="/index.html">
          <h1 class="logo">
            <img src="../assets/images/common/ci-wavve.svg" alt="Wavve" />
          </h1>
        </a>
      </div>
      <div class="error-page">
        <img
          src="../assets/images/common/icon-error-74.png"
          alt="에러 아이콘"
        />
        <p class="error-txt01" v-html="title"></p>
        <p class="error-txt02" v-html="text"></p>
        <div class="btn-purple">
          <a href="/index.html"> 홈으로 가기 </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, defineProps } from 'vue'
  import { getTextBreaks } from '@/common/utils/string-manipulation/get-text-breaks'

  const DEFAULT_TITLE_404 = '서비스 이용에 불편을 드려 죄송합니다.'
  const DEFAULT_TEXT_404 = `찾으시는 페이지가 없거나 오류가 발생하였습니다.\n입력하신 주소가 정확한지 다시한번 확인해 주세요.\n\n관련 문의사항은 고객센터 1599-3709로 문의하시면 친절하게 안내해드리겠습니다.`

  const props = defineProps({
    errorTitle: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
  })

  const title = computed(() =>
    getTextBreaks(props.errorTitle || DEFAULT_TITLE_404),
  )
  const text = computed(() =>
    getTextBreaks(props.errorText || DEFAULT_TEXT_404),
  )
</script>
